import { render } from "./MobileStaticHome.vue?vue&type=template&id=233459b9&scoped=true"
import script from "./MobileStaticHome.vue?vue&type=script&lang=js"
export * from "./MobileStaticHome.vue?vue&type=script&lang=js"

import "./MobileStaticHome.vue?vue&type=style&index=0&id=233459b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233459b9"]])

export default __exports__